import AppConfig from '../config'

const channelUrlPattern = new RegExp(`^${AppConfig.routes.channel('.*')}`)

export const isPageChannel = (relativeUrl: string) => {
  return Boolean(relativeUrl.match(channelUrlPattern))
}
